// extracted by mini-css-extract-plugin
export default {"userManagement":"UserManagement_userManagement__DcM8v","contentTitle":"UserManagement_contentTitle__P8y4Z"};